import { Typography } from '@mui/material';
import { Metric } from '@strength/domain';
import { I18nTranslator } from '@strength/i18n';
import { CustomSlot } from '../../../../components/sheet/slots';
import { WorkoutWithCycleAndSession } from '../../types';
import {
  ActualWorkout,
  BlockSummarySelectionData,
  BlockSummarySlot,
  WorkoutSummaryActualsMutationFns,
  WorkoutSummaryPrescriptionMutationFns,
} from '../types';
import { getActualSlotsForMetricValue } from './getActualsSlots';
import { getPrescriptionSlotsForMetricValue } from './getPrescriptionSlots';

const MATCH = 'Match';
const TRAINING = 'Training';
const MODIFIED = 'Modified';

export const getPlannedSlots = (
  workouts: WorkoutWithCycleAndSession[],
  month: number,
  year: number,
  currentY: number,
  mutationFns: WorkoutSummaryPrescriptionMutationFns,
  getMetric: (metricId: string) => Metric,
  t: I18nTranslator,
  readOnly?: boolean,
) => {
  const slots: BlockSummarySlot[] = [];
  let currentX = 0;
  // Add row for Match header
  slots.push(
    new CustomSlot<BlockSummarySelectionData>(
      { x: currentX++, y: currentY },
      1,
      1,
      false,
      () => <Typography variant="subtitle1">{t('match')}</Typography>,
      {
        className: 'p-2',
        disableContextMenu: true,
      },
    ),
  );

  slots.push(
    ...getPrescriptionSlotsForMetricValue(
      MATCH,
      workouts,
      mutationFns,
      month,
      year,
      currentX,
      currentY,
      getMetric,
      readOnly,
    ),
  );

  // Reset currentX, increment currentY for next row
  currentX = 0;
  currentY++;

  // Add row for Training header
  slots.push(
    new CustomSlot<BlockSummarySelectionData>(
      { x: currentX++, y: currentY },
      1,
      1,
      false,
      () => <Typography variant="subtitle1">{t('training')}</Typography>,
      {
        className: 'p-2',
        disableContextMenu: true,
      },
    ),
  );

  slots.push(
    ...getPrescriptionSlotsForMetricValue(
      TRAINING,
      workouts,
      mutationFns,
      month,
      year,
      currentX,
      currentY,
      getMetric,
      readOnly,
    ),
  );

  // Reset currentX, increment currentY for next row
  currentX = 0;
  currentY++;

  // Add row for Modified header
  slots.push(
    new CustomSlot<BlockSummarySelectionData>(
      { x: currentX++, y: currentY },
      1,
      1,
      false,
      () => <Typography variant="subtitle1">{t('modified')}</Typography>,
      {
        className: 'p-2',
        disableContextMenu: true,
      },
    ),
  );

  slots.push(
    ...getPrescriptionSlotsForMetricValue(
      MODIFIED,
      workouts,
      mutationFns,
      month,
      year,
      currentX,
      currentY,
      getMetric,
      readOnly,
    ),
  );
  return slots;
};

export const getActualSlots = (
  workouts: ActualWorkout[],
  mutationFns: WorkoutSummaryActualsMutationFns,
  month: number,
  year: number,
  currentY: number,
  getMetric: (metricId: string) => Metric,
  t: I18nTranslator,
  readOnly?: boolean,
) => {
  const slots: BlockSummarySlot[] = [];
  let currentX = 0;

  // Add row for Match header
  slots.push(
    new CustomSlot<BlockSummarySelectionData>(
      { x: currentX++, y: currentY },
      1,
      1,
      false,
      () => <Typography variant="subtitle1">{t('match')}</Typography>,
      {
        className: 'p-2',
        disableContextMenu: true,
      },
    ),
  );

  slots.push(
    ...getActualSlotsForMetricValue(
      MATCH,
      workouts,
      mutationFns,
      month,
      year,
      currentX,
      currentY,
      getMetric,
      t,
      readOnly,
    ),
  );

  // Reset currentX, increment currentY for next row
  currentX = 0;
  currentY++;

  // Add row for Training header
  slots.push(
    new CustomSlot<BlockSummarySelectionData>(
      { x: currentX++, y: currentY },
      1,
      1,
      false,
      () => <Typography variant="subtitle1">{t('training')}</Typography>,
      {
        className: 'p-2',
        disableContextMenu: true,
      },
    ),
  );

  slots.push(
    ...getActualSlotsForMetricValue(
      TRAINING,
      workouts,
      mutationFns,
      month,
      year,
      currentX,
      currentY,
      getMetric,
      t,
      readOnly,
    ),
  );

  // Reset currentX, increment currentY for next row
  currentX = 0;
  currentY++;

  // Add row for Modified header
  slots.push(
    new CustomSlot<BlockSummarySelectionData>(
      { x: currentX++, y: currentY },
      1,
      1,
      false,
      () => <Typography variant="subtitle1">{t('modified')}</Typography>,
      {
        className: 'p-2',
        disableContextMenu: true,
      },
    ),
  );

  slots.push(
    ...getActualSlotsForMetricValue(
      MODIFIED,
      workouts,
      mutationFns,
      month,
      year,
      currentX,
      currentY,
      getMetric,
      t,
      readOnly,
    ),
  );
  return slots;
};
